import { createStyles, withStyles } from '@material-ui/styles';
import cn from 'classnames';
import * as React from 'react';
import { compose, pure, withHandlers } from 'recompose';
import { border } from '@topconagriculture/theme';
import { Button } from '../Button';
const styles = (theme) => {
    const defaultUnit = 50;
    const smallUnit = 35;
    const bigUnit = 60;
    const paddingRatio = 1.8;
    return createStyles({
        container: {
            borderRadius: theme.common.borderRadius.default,
            overflow: 'hidden',
            position: 'relative',
            height: defaultUnit,
            zIndex: 100,
            padding: `0 ${paddingRatio * defaultUnit}px`,
            border: border(theme.color.grey.light),
        },
        small: {
            padding: `0 ${paddingRatio * smallUnit}px`,
            height: smallUnit,
            '& $tallyButton': {
                width: smallUnit,
                minWidth: smallUnit,
                fontSize: theme.font.size.title,
                paddingTop: theme.space.padding.smallest,
            },
            '& $field': {
                fontSize: theme.font.size.big,
            },
        },
        big: {
            padding: `0 ${paddingRatio * bigUnit}px`,
            height: bigUnit,
            '& $tallyButton': {
                width: bigUnit,
                minWidth: bigUnit,
            },
        },
        tallyButton: {
            position: 'absolute',
            top: 0,
            height: '100%',
            width: defaultUnit,
            zIndex: 102,
            borderRadius: 0,
            minWidth: defaultUnit,
            fontSize: theme.font.size.heading,
            lineHeight: 0,
            paddingBottom: theme.space.padding.small,
            fontWeight: theme.font.weight.light,
        },
        leftButton: {
            left: 0,
        },
        rightButton: {
            right: 0,
        },
        field: {
            position: 'absolute',
            border: 'none',
            left: 0,
            top: 0,
            width: '100%',
            height: '100%',
            zIndex: 101,
            textAlign: 'center',
            fontSize: theme.font.size.title,
            fontWeight: theme.font.weight.bold,
            paddingTop: 3,
            backgroundColor: 'white',
        },
    });
};
const TallyCounter = (props) => {
    const { className: classNameProp, classes, value, handleAdd, handleSubtract, handleChange, min, max, editable, testId = 'TallyCounter', size, } = props;
    const containerClasses = cn(classes.container, classNameProp, size && classes[size]);
    const extendBtn = (className) => cn(classes.tallyButton, className);
    return (React.createElement("div", { className: containerClasses, "data-testid": `${testId}` },
        React.createElement(Button, { "data-testid": `${testId}-subtract`, disabled: value === min, className: extendBtn(classes.leftButton), onClick: handleSubtract, label: "-" }),
        React.createElement("input", { "data-testid": `${testId}-input`, type: "text", className: classes.field, value: value, onChange: handleChange, min: min, max: max, disabled: !editable }),
        React.createElement(Button, { "data-testid": `${testId}-add`, disabled: value === max, className: extendBtn(classes.rightButton), onClick: handleAdd, label: "+" })));
};
const ComposedTallyCounter = compose(withStyles(styles, { withTheme: true }), pure, withHandlers({
    handleChange: ({ onChange, max, min }) => (val) => {
        let newVal = typeof val === 'object' ? val.target.value : val;
        if (max && newVal > max) {
            newVal = max;
        }
        else if (min && newVal < min) {
            newVal = min;
        }
        onChange(newVal ? parseInt(String(newVal), 10) : 0);
    },
}), withHandlers({
    handleAdd: ({ value, handleChange }) => () => {
        handleChange(value + 1);
    },
    handleSubtract: ({ value, handleChange }) => () => {
        handleChange(value - 1);
    },
}))(TallyCounter);
ComposedTallyCounter.displayName = 'TallyCounter';
export default ComposedTallyCounter;
//# sourceMappingURL=TallyCounter.js.map